import { apiGateway } from "@/shared/apiGateway";

const getPlantsWithoutStatInspListing = (
  context,
  { clientId, contractorRegionId, searchCriteria }
) => {
  var url = "api/statutoryInspections/plants-without-stat-insp";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (clientId !== undefined) {
    url = url + "&clientId=" + clientId;
  }
  if (contractorRegionId !== undefined) {
    url = url + "&contractorRegionId=" + contractorRegionId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEDPLANTSWITHOUTSTATINSP", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting plants without Stat. Insp."],
        { root: true }
      );
    });
};

const getStatInspListing = (
  context,
  { clientId, contractorRegionId, filterCriteria, searchCriteria }
) => {
  var url = "api/statutoryInspections";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (clientId !== undefined) {
    url = url + "&clientId=" + clientId;
  }
  if (contractorRegionId !== undefined) {
    url = url + "&contractorRegionId=" + contractorRegionId;
  }
  if (filterCriteria.statInspStatusId !== 0) {
    url = url + "&statInspStatus=" + filterCriteria.statInspStatusId;
  }
  if (filterCriteria.plantState === 2) {
    url = url + "&plantState=" + filterCriteria.plantState;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEDSTATINSPS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Statutory Inspections"],
        {
          root: true
        }
      );
    });
};

const getStatInsp = (context, statInspId) => {
  return apiGateway
    .apiGatewayGET("api/statutoryInspections/" + statInspId)
    .then(data => {
      context.commit("STATINSP_SETSTATINSP", data);
      context.commit("STATINSP_UPDATESTATINSPITEMS", data.statInspItems);
    })
    .catch(error => {
      console.error(error);
      context.commit("STATINSP_SETSTATINSP", undefined);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Stat. Insp. - " + error.response.data],
        {
          root: true
        }
      );
    });
};

const getStatInspItemDetail = (context, statInspItemId) => {
  return apiGateway
    .apiGatewayGET(
      "api/statutoryInspections/get-stat-insp-item/" + statInspItemId
    )
    .then(data => {
      context.commit("STATINSP_SETSTATINSPITEM", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat. Insp. item"], {
        root: true
      });
    });
};

const createStatInspItemNote = (commit, body) => {
  body.noteType = 1;
  return apiGateway.apiGatewayPATCH(
    "api/statutoryInspections/update-stat-insp-item-notes",
    body
  );
};

const updateStatInspItemStatus = (commit, statInspItemStatus) => {
  statInspItemStatus.noteType = 1;
  return apiGateway
    .apiGatewayPATCH(
      "api/statutoryInspections/update-stat-insp-item-status/",
      statInspItemStatus
    )
    .then(data => {
      return data;
    });
};

const getPagedStatInspItems = (
  context,
  { clientId, contractorRegionId, filterCriteria, searchCriteria }
) => {
  var url = "api/statutoryInspections/paged-stat-insp-items";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (clientId !== undefined) {
    url = url + "&clientId=" + clientId;
  }
  if (contractorRegionId !== undefined) {
    url = url + "&contractorRegionId=" + contractorRegionId;
  }
  url = url + "&statInspItemStatus=" + filterCriteria.statInspItemStatusId;

  if (filterCriteria.statInspItemTypeId !== 0) {
    url = url + "&statInspItemType=" + filterCriteria.statInspItemTypeId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit("STATINSP_UPDATEPAGESSTATINSPITEMS", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Stat Insp Items"], {
        root: true
      });
    });
};

const createStatInsp = (commit, { statInsp }) => {
  return apiGateway
    .apiGatewayPOST(
      "api/statutoryInspections/create-statutory-inspection",
      statInsp
    )
    .then(data => {
      return data;
    });
};

const createNextStatInspReport = (commit, statInsp) => {
  return apiGateway
    .apiGatewayPOST(
      "api/statutoryInspections/create-next-statutory-inspection",
      statInsp
    )
    .then(data => {
      return data;
    });
};

const createStatInspItem = (commit, { statInspItem }) => {
  return apiGateway
    .apiGatewayPOST(
      "api/statutoryInspections/create-stat-insp-item",
      statInspItem
    )
    .then(data => {
      return data;
    });
};

const updateStatInspItem = (commit, { form }) => {
  return apiGateway
    .apiGatewayPUT("api/statutoryInspections/update-stat-insp-item", form)
    .then(data => {
      return data;
    });
};

const updateStatInsp = (commit, { form }) => {
  return apiGateway
    .apiGatewayPATCH(
      "api/statutoryInspections/update-statutory-inspection",
      form
    )
    .then(data => {
      return data;
    });
};

const deleteStatInspItem = (context, id) => {
  return apiGateway
    .apiGatewayDELETE("api/statutoryInspections/delete-stat-insp-item?id=" + id)
    .then(() => {
      context.commit("delete_item_by_id", id);
      return;
    });
};

const closeRepeatedStatInspItemAgainstPreviousStatInsp = (
  commit,
  statInspItemId
) => {
  return apiGateway
    .apiGatewayPATCH(
      "api/statutoryInspections/close-stat-insp-item-against-previous-report?statInspItemId=" +
        statInspItemId
    )
    .then(data => {
      return data;
    });
};

const createStatInspItemQuote = (commit, form) => {
  form.noteType = 1;
  return apiGateway
    .apiGatewayPATCH(
      "api/statutoryInspections/create-stat-insp-item-quote",
      form
    )
    .then(data => {
      return data;
    });
};

export default {
  createStatInspItemNote,
  deleteStatInspItem,
  getStatInsp,
  getStatInspItemDetail,
  getStatInspListing,
  getPagedStatInspItems,
  getPlantsWithoutStatInspListing,
  updateStatInspItemStatus,
  createStatInsp,
  createStatInspItem,
  updateStatInspItem,
  updateStatInsp,
  createNextStatInspReport,
  closeRepeatedStatInspItemAgainstPreviousStatInsp,
  createStatInspItemQuote
};
